const BADGE_CLASSNAMES = 'badge badge-pill bg-gray ml-auto';

export function createLabelEl(item, num) {
  const hasChild = _.has(item, 'children');
  const hasURL = _.has(item, 'url');

  const labelClass = 'd-flex label noselect';

  // span.text
  const labelTextEl = $('<div/>', { class: 'text-wrap' })
    .append([
      $('<span/>', { class: 'num', text: `${num}. ` }),
      // [#13] sidebar의 글자에 tooltip 설정
      $('<span/>', { class: 'text', text: item.label }).append($('<span/>', { class: 'tooltiptext', text: item.label })),
    ]);

  let labelChildren = [
    labelTextEl,
  ];

  let labelEl;
  if (!hasChild && !hasURL) {
    labelEl = $('<div/>', { class: labelClass });
  } else {
    let anchorURL;
    let anchorContentId;
    if (hasChild && !hasURL) { // 폴더 아이템
      const childCountEl = $('<div/>', {
        class: `${BADGE_CLASSNAMES} child-count`,
        text: item.children.length,
      });
      const filterCountEl = $('<div/>', {
        class: `${BADGE_CLASSNAMES} filter-count`,
        text: '',
      });
      labelChildren = _.concat(labelChildren, [
        childCountEl,
        filterCountEl,
      ]);
      anchorURL = `#${item.name}`;
    } else { // 문서 아이템
      anchorURL = item.url;
      anchorContentId = item.cid;
      // anchorClasses = ['md'];
    }
    labelEl = $('<a/>', {
      class: `${labelClass} link-item`,
      'data-url': anchorURL,
      cid: anchorContentId,
    });
  }

  // CSS로 대체
  // 그룹 아이템이면, 자식이 있으면,
  // if (hasChild) {
  //   // 폴더아이콘 추가
  //   const labelIconEl = $('<i/>', { class: 'far fa-folder' });
  //   labelChildren.unshift(labelIconEl);
  // }

  return labelEl.append(labelChildren);
}
